import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { getMemberTestimonialImages, deleteTestimonialImage } from "../../store/actions";
import PlaceholderImage from "../../sharedComponents/placeholderImage";

import ConfirmDelete from "../../sharedComponents/confirmDelete";
import "./Testimonials.scss";
import AddImagesPanel from "./addTestimonialImagesPanel";

const AddTestimonialImages = ({
	testimonialData,
	getMemberTestimonialImages,
	imageList,
	deleteTestimonialImage,
	setActiveTab
}) => {
	const [showAddImagePanel, toggleAddImagePanel] = useState(true);
	const [editData, setEditData] = useState(0);
	const [deleteItem, setDeleteItem] = useState(null);
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		testimonialData && testimonialData.member && getMemberTestimonialImages(`member=${testimonialData.member}`);
	}, [getMemberTestimonialImages, testimonialData]);

	const handleEdit = (data) => {
		setEditData(data);
		toggleAddImagePanel(true);
	};

	const handleDelete = (data) => {
		setDeleteItem(data);
	};

	const confirmEvent = (yes) => {
		const successHandler = (event) => {
			getMemberTestimonialImages(`member=${testimonialData.member}`);
		};

		if (yes && deleteItem) {
			deleteTestimonialImage(deleteItem, successHandler);
			setShowModal(false);
			setDeleteItem(null);
		} else {
			setDeleteItem(null);
		}
	};

	return (
		<div className="p-4">
			<div className="row card-wrap">
				<div className="col-2 mb-4" onClick={() => toggleAddImagePanel(true)}>
					<div className="add-image-card">
						<i className="icon icon-plus lg-icon" />
						<div className="mt-2">Add an image</div>
					</div>
				</div>
				{imageList &&
					imageList.results &&
					imageList.results.map((item, index) => {
						return (
							<div key={index} className="col-2 mb-4">
								<div className="card card-default h-100">
									<div className="card-nav">
										<button
											className="btn btn-danger btn-cell btn-sm"
											type="button"
											onClick={() => handleDelete(item)}>
											<i className="icon icon-trash" />
										</button>
										<button
											className="btn btn-success btn-cell btn-sm mr-2"
											onClick={() => handleEdit(item)}>
											<i className="icon icon-edit"></i>
										</button>
									</div>
									<PlaceholderImage
										className="card-image"
										src={item.photo_l}
										objectFit="cover"
										width="200"
										height="150"
									/>
									<div className="card-title">{item.name}</div>
								</div>
							</div>
						);
					})}

				<AddImagesPanel
					setActiveTab={setActiveTab}
					showAddImagePanel={showAddImagePanel}
					toggleAddImagePanel={toggleAddImagePanel}
					member={testimonialData.member}
					initialValues={editData ? editData : {}}
					onReset={() => setEditData(null)}
				/>
				<ConfirmDelete
					item={deleteItem ? deleteItem : showModal}
					message={<div>Are you sure you want to delete?</div>}
					onEvent={confirmEvent}
				/>
			</div>
			<p> *Please upload images having minimum width of 200 with a W x H ratio of : 2 x 3</p>
			<div className="d-flex flex-row justify-content-end mt-3">
				<button
					type="submit"
					className="btn btn-primary-dark text-uppercase"
					onClick={() => {
						testimonialData &&
							testimonialData.member &&
							getMemberTestimonialImages(`member=${testimonialData.member}`);
						setActiveTab(2);
					}}>
					SAVE & NEXT
				</button>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { Testimonials } = state;
	return {
		imageList: get(Testimonials, "testimonialImageList", {}),
		sourceList: get(state, "AddRecipe.sourceList.results", []),
		testimonialData: get(Testimonials, "testimonialDetail", {})
	};
};

const mapDispatchToProps = { getMemberTestimonialImages, deleteTestimonialImage };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AddTestimonialImages);
